<template>
  <div class="permission-transactions-list">
    <div class="permission-transactions__filters-wrp">
      <div class="app-list-filters">
        <select-field
          class="permission-transctions__field app-list-filters__field"
          :label="'permission-transactions.lbl-action' | globalize"
          v-model="filters.action"
        >
          <option
            v-for="(item, Id) in actions"
            :key="`${item}-${Id}`"
            :value="item"
          >
            {{ item }}
          </option>
        </select-field>
        <select-field
          class="permission-transctions__field app-list-filters__field"
          :label="'permission-transactions.lbl-role' | globalize"
          v-model="filters.role"
        >
          <option
            v-for="(item, Id) in roles"
            :key="`${item}-${Id}`"
            :value="item"
          >
            {{ item }}
          </option>
        </select-field>
        <select-field
          class="permission-transctions__field app-list-filters__field"
          :label="'permission-transactions.lbl-status' | globalize"
          v-model="filters.status"
        >
          <option
            v-for="(item, Id) in statuses"
            :key="`${item}-${Id}`"
            :value="item"
          >
            {{ item }}
          </option>
        </select-field>
        <button
          v-ripple
          class="
            permission_transactions__btn
           app__button-raised"
          @click="reloadList"
        >
          {{ 'permission-transactions.btn-refresh' | globalize }}
        </button>
      </div>
    </div>

    <a-table
      size="small"
      :data-source="transactionsList"
      :row-key="record=>record.id"
      :pagination="false"
      :columns="columns">
      <template
        slot="user-id-column"
        slot-scope="userId, item">
        <copyable :copy-text="item.userId">
          <a
            :value="item.user_id"
            type="user_id"
            :href="'/users/' + userId"
          >{{ userId }}</a>
        </copyable>
      </template>
      <template
        slot="address-column"
        slot-scope="address, item">
        <copyable :copy-text="item.address">
          <eth-link
            :value="item.address"
            type="address"
            :explorer-url="item.explorerUrl"
          />
        </copyable>
      </template>
      <template
        slot="url-column"
        slot-scope="txHash, item">
        <copyable :copy-text="item.txHash">
          <eth-link
            :value="item.txHash"
            type="tx"
            :explorer-url="item.explorerUrl"
          />
        </copyable>
      </template>
      <template
        slot="createdAt"
        slot-scope="text">
        {{ text | formatDateDMYT }}
      </template>
      <template
        slot="actions"
        slot-scope="item">
        <button
          v-ripple
          class="
            permission_transactions__btn
            app__button-raised
            app__button-raised--warning"
          @click="resetPermissionJob(item.id)"
        >
          {{ 'permission-transactions.btn-reset-job' | globalize }}
        </button>
        <button
          v-ripple
          class="
            permission_transactions__btn
            app__button-raised
            app__button-raised--danger"
          @click="deletePermissionJob(item.id)"
        >
          {{ 'permission-transactions.btn-delete-job' | globalize }}
        </button>
      </template>
    </a-table>
    <div class="app__more-btn-wrp">
      <collection-loader
        class="app__more-btn-wrp"
        :first-page-loader="getTransactions"
        @first-page-load="setList"
        @next-page-load="concatList"
        ref="collectionLoaderBtn"
      />
    </div>
  </div>
</template>

<script>
import { globalize } from '@/vue/filters/globalize'
import SelectField from '@/vue/fields/SelectField'
import { ErrorHandler } from '@/js/helpers/error-handler'
import { clearObject } from '@/js/helpers/clear-object'
import { api } from '@/api'
import { NftTransactionRecord } from '@/js/records/entities/nft-transaction.record'
import EthLink from '@/vue/common/eth-link'
import Copyable from '@/vue/common/copyable/Copyable'
import { Bus } from '@/js/helpers/event-bus'
import { shortener } from '@/js/helpers/string'
import { etherscanUrl } from '@/js/helpers/urls'
import ATable from 'ant-design-vue/lib/table'
import CollectionLoader from '@/vue/common/CollectionLoader'

const columns = ctx => {
  /* eslint-disable-next-line */
  const h = ctx.$createElement
  return [
    {
      dataIndex: 'id',
      key: 'id',
      title: globalize('user-nft-transactions.lbl-id'),
    },
    {
      dataIndex: 'userId',
      key: 'userId',
      title: globalize('user-nft-transactions.lbl-userId'),
      scopedSlots: { customRender: 'user-id-column' },
    },
    {
      dataIndex: 'address',
      key: 'address',
      title: globalize('user-nft-transactions.lbl-address'),
      scopedSlots: { customRender: 'address-column' },
    },
    {
      dataIndex: 'action',
      key: 'action',
      title: globalize('user-nft-transactions.lbl-action'),
    },
    {
      dataIndex: 'role',
      key: 'role',
      title: globalize('user-nft-transactions.lbl-role'),
    },
    {
      dataIndex: 'status',
      key: 'status',
      title: globalize('user-nft-transactions.lbl-status'),
    },
    {
      dataIndex: 'retryCount',
      key: 'retryCount',
      title: globalize('user-nft-transactions.lbl-retryCount'),
    },
    {
      dataIndex: 'txHash',
      key: 'txHash',
      title: globalize('user-nft-transactions.lbl-txHash'),
      scopedSlots: { customRender: 'url-column' },
    },
    {
      dataIndex: 'reason',
      key: 'reason',
      title: globalize('user-nft-transactions.lbl-reason'),
    },
    {
      dataIndex: 'chain',
      key: 'chain',
      title: globalize('user-nft-transactions.lbl-chain'),
      customRender: (str, record) => {
        return `${record.chainName}`
      },
    },
    {
      dataIndex: 'createdAt',
      key: 'createdAt',
      title: globalize('user-nft-transactions.lbl-createdAt'),
      scopedSlots: { customRender: 'createdAt' },
    },
    {
      key: 'actions',
      title: globalize('user-nft-transactions.lbl-actions'),
      scopedSlots: { customRender: 'actions' },
    },
  ]
}

export default {
  components: {
    SelectField,
    CollectionLoader,
    'copyable': Copyable,
    EthLink,
    ATable,
  },
  data () {
    return {
      isPending: false,
      isLoaded: false,
      isFailed: false,
      transactionsList: [],
      statuses: ['not_started', 'pending', 'to_retry', 'failed', 'done'],
      actions: ['assign', 'revoke', 'parent'],
      roles: ['tier1', 'tier2', 'tier90', 'tier99', 'vmatr_whitelist', 'source_of_funds'],
      filters: {
        status: '',
        action: '',
        role: '',
      },
    }
  },
  computed: {
    columns () {
      const result = columns(this)

      return result
    },
  },
  watch: {
    filters: {
      handler () {
        this.isPending = true
        if (this.isLoaded) {
          this.reloadList()
        }
      },
      deep: true,
    },
    isLoaded: {
      handler (value) {
        if (value && this.isPending) {
          this.reloadList()
          this.isPending = false
        }
      },
    },
  },

  async created () {
    await this.getTransactions()
  },

  methods: {
    async resetPermissionJobs () {
      try {
        await api.postWithSignature('/dev/reset_permission_jobs?user_id=' + this.id, '{}')
        Bus.success('user-nft-transactions.success-permission-reset-message')
        this.reloadList()
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      }
    },
    async resetPermissionJob (jobID) {
      try {
        await api.postWithSignature('/dev/reset_permission_job?job_id=' + jobID, '{}')
        Bus.success('user-nft-transactions.success-job-reset-message')
        this.reloadList()
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      }
    },
    async deletePermissionJob (jobID) {
      try {
        await api.postWithSignature('/dev/delete_permission_job?job_id=' + jobID, '{}')
        Bus.success('user-nft-transactions.success-job-delete-message')
        this.reloadList()
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      }
    },
    async getTransactions () {
      this.isLoaded = false
      this.isFailed = false

      let response = {}
      try {
        const query = {
          filter: clearObject({
            user_id: this.id,
            status: this.filters.status,
            action: this.filters.action,
            role: this.filters.role,
            parent_id: this.filters.parentId,
          }),
        }

        response = await api.getWithSignature('/transactions', query)

        this.transactionsList = response.data.map(i => new NftTransactionRecord(i))

        return response
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
        this.isFailed = true
      } finally {
        this.isLoaded = true
        this.isPending = false
      }
    },

    reloadList () {
      this.$refs.collectionLoaderBtn.loadFirstPage()
    },

    setList (data) {
      this.transactionsList = data.map((i) => new NftTransactionRecord(i))
    },

    concatList (data) {
      this.transactionsList = this.transactionsList.concat(
        data.map((i) => new NftTransactionRecord(i))
      )
    },
    shortener,
    etherscanUrl,
  },
}
</script>

<style lang="scss" scoped>
@import '~ant-design-vue/lib/table/style/index.css';

.permission-transctions__list-wrp {
  margin-top: 4rem;
}

.permission-transctions__field {
  min-width: 16.5rem;
}

.user-transactions__btn {
  min-width: 16.5rem;
}
</style>
